import { render, staticRenderFns } from "./VReviewAdd.vue?vue&type=template&id=bf527e7e&scoped=true&"
import script from "./VReviewAdd.vue?vue&type=script&lang=js&"
export * from "./VReviewAdd.vue?vue&type=script&lang=js&"
import style0 from "./VReviewAdd.vue?vue&type=style&index=0&id=bf527e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf527e7e",
  null
  
)

export default component.exports